
















import {Vue, Component, Watch} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import MallsTab from '@/components/common/MallsTab.vue';
import SmsUsageListSearch from '@/components/manage/sms/SmsUsageListSearch.vue';
import SmsUsageListSummary from '@/components/manage/sms/SmsUsageListSummary.vue';
import SmsUsageListDetail from '@/components/manage/sms/SmsUsageListDetail.vue';
import {GetSmsUsagesViewRequest, Mall, GetSmsUsagesView} from 'supporter';
import {State, namespace} from 'vuex-class';
const mallModule = namespace('mall');

@Component({
  components: {PageTitle, MallsTab, SmsUsageListSearch, SmsUsageListSummary, SmsUsageListDetail}
})
export default class SmsUsageList extends Vue {
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: number = 0;  
  private searchForm: GetSmsUsagesViewRequest = {
    params: {
      mallNo: 0,
      year: 0,
      month: 1,
      messageType: ''
    }
  };
  private summaryData: object[] = [];
  private detailData: object[] = [];

  private setVal(params: GetSmsUsagesViewRequest) {
    this.searchForm = params;
  }

  private search() {
    this.summaryData = [];
    this.detailData = [];

    this.$api.getSmsUsagesView(this.searchForm).then(res => {
      const summaryObj = {
        period: `${this.searchForm.params.year}${this.$t('COMMON_YEAR')} ${this.searchForm.params.month}${this.$t('COMMON_MONTH')}`,
        messageType: this.searchForm.params.messageType === '' ? this.$t('MANAGE_SMS_MESSAGETYPE_ALL') : this.searchForm.params.messageType,
        summaryUsageAmount: 0,
        summaryUsagePrice: 0
      };
      res.data.forEach((obj: GetSmsUsagesView) => {
        summaryObj.summaryUsageAmount += obj.amount;
        summaryObj.summaryUsagePrice += obj.totalPrice;
        const detailObj = {
          period: `${this.searchForm.params.year}${this.$t('COMMON_YEAR')} ${this.searchForm.params.month}${this.$t('COMMON_MONTH')}`,
          messageType: obj.messageType,
          amount: obj.amount,
          price: obj.price,
          totalPrice: obj.totalPrice
        };
        this.detailData.push(detailObj);
      });
      this.summaryData.push(summaryObj);
    });
  }
  private toFirstPage() {
    const url = `/sms/send-list?mallNo=${this.mallNo}&tabNo=1`;
    window.location.assign(url);
  }

  @Watch('$route.query.mallNo', {immediate: false, deep: false})
  async onMallChanged() {
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
    this.toFirstPage();

  }
  private async mounted() {
    await this.fetchMalls();
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    } 
    this.search();
  }
}
